import { render, staticRenderFns } from "./FPaymentPlan.vue?vue&type=template&id=120db70b&"
import script from "./FPaymentPlan.vue?vue&type=script&lang=ts&"
export * from "./FPaymentPlan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports